import close from "./close.svg";

import styles from "./Popup.module.scss";

interface PopupProps {
  show: boolean;
  title: string;
  children: React.ReactNode;
  permanent?: boolean;
  onHide?: () => void;
}

const Popup = ({ show, title, children, permanent, onHide }: PopupProps) => {
  if (!show) return null;

  const content = (
    <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
      {!permanent && <img src={close} alt="close" onClick={() => onHide?.()} />}
      <h1>{title}</h1>
      {children}
    </div>
  );

  if (permanent) {
    return <div className={styles.position}>{content}</div>;
  }

  return <div className={styles.overlay}>{content}</div>;
};

export default Popup;
